import { defineAction } from '~/prix'
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'
import trainingPerformedReportAction from './trainingPerformedReport.action.json' with { type: 'json' }

const trainingPerformedReportDefinition = defineAction({
  ...trainingPerformedReportAction,

  input: z.object({
    format: reportFormatSchema,
    startDate: z.union([z.string(), z.date()]).nullish(),
    endDate: z.union([z.string(), z.date()]).nullish(),
    trainingType: z.string().nullish(),
    citizenId: z.string().uuid().nullish(),
  }),
  output: z.any(),
})

export default trainingPerformedReportDefinition
